var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmailIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "35px",
    viewBox: "0 0 48 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(0.00106362,0,0,-0.0010718,9.067972,8.264821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.254902%,96.470588%,93.72549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.588235%,89.411765%,83.921569%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(0.00106362,0,0,-0.0010718,9.067972,8.264821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.254902%,96.470588%,93.72549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.588235%,89.411765%,83.921569%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(0.00106362,0,0,-0.0010718,9.067972,8.264821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.254902%,96.470588%,93.72549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.588235%,89.411765%,83.921569%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(0.00106362,0,0,-0.0010718,9.067972,8.264821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.254902%,96.470588%,93.72549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.588235%,89.411765%,83.921569%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(0.00106362,0,0,-0.0010718,9.067972,8.264821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.254902%,96.470588%,93.72549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.588235%,89.411765%,83.921569%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(0.00106362,0,0,-0.0010718,9.067972,8.264821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.254902%,96.470588%,93.72549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.588235%,89.411765%,83.921569%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(0.00106362,0,0,-0.0010718,9.067972,8.264821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.254902%,96.470588%,93.72549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.588235%,89.411765%,83.921569%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(0.00106362,0,0,-0.0010718,9.067972,8.264821)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(97.254902%,96.470588%,93.72549%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.588235%,89.411765%,83.921569%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588235%,35.294118%,30.196078%)",
      fillOpacity: 1
    },
    d: "M 44.0625 0.00390625 C 46.222656 0.00390625 47.992188 1.785156 47.992188 3.964844 L 47.992188 5.113281 L 42.53125 9.046875 L 23.929688 21.957031 L 5.332031 8.914062 L 5.332031 34.996094 L 3.933594 34.996094 C 1.769531 34.996094 0 33.214844 0 31.035156 L 0 3.964844 C 0 1.785156 1.769531 0.00390625 3.933594 0.00390625 L 23.929688 14.945312 L 44.058594 0.00390625 Z M 44.0625 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588235%,89.411765%,84.313725%)",
      fillOpacity: 1
    },
    d: "M 5.332031 8.914062 L 5.332031 34.996094 L 42.53125 34.996094 L 42.53125 9.046875 L 23.929688 21.957031 Z M 5.332031 8.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.156863%,71.764706%,68.235294%)",
      fillOpacity: 1
    },
    d: "M 5.332031 34.996094 L 23.929688 21.957031 L 23.847656 21.898438 L 5.332031 34.710938 Z M 5.332031 34.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(71.764706%,71.372549%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 42.53125 9.046875 L 42.542969 34.996094 L 23.929688 21.957031 Z M 42.53125 9.046875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(69.803922%,22.352941%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 47.992188 5.113281 L 48 31.039062 C 47.90625 33.917969 46.667969 34.949219 42.542969 34.996094 L 42.53125 9.046875 L 47.996094 5.113281 Z M 47.992188 5.113281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.078431%,92.941176%)",
      fillOpacity: 1
    },
    d: "M 3.933594 0.00390625 L 23.929688 14.945312 L 44.0625 0.00390625 Z M 3.933594 0.00390625 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon1);
export default __webpack_public_path__ + "static/media/gmail-icon(1).82e5bc3846dcbbdbd0d42b6dd1971f43.svg";
export { ForwardRef as ReactComponent };